/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "../../styles/containers/ViewCheckups.scss";
import PaperCard from "../../components/PaperCard";
import { backgroundColor, ratingColor } from "../../Constants";
import { withStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import StarsIcon from "@material-ui/icons/Stars";
import Dropdown from "../../components/Dropdown";
import { Grid } from "@material-ui/core";
import Loader from "../../components/Loader";
import {
  getAllStations,
  getModules,
  getTasks,
  getTaskDes,
  fetchTaskDes,
  fetchTasks,
  fetchModules,
  getModulesAndStationRating,
  getAllCheckUpdates,
} from "../../store/actions/stationsActions";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Message from "../../components/Message";
import { matchPath, withRouter } from "react-router";
import { useHistory } from "react-router";

const StyledRating = withStyles({
  iconFilled: {
    color: ratingColor.red,
  },
  iconHover: {
    color: ratingColor.red,
  },
})(Rating);

function ViewCheckups({
  getAllStations,
  getModules,
  getAllCheckUpdates,
  getTasks,
  isFetchedModules,
  isFetchedTasks,
  isFetchedStations,
  isFetchedCheckUpdates,
  tasks,
  modules,
  stations,
  modulesError,
  tasksError,
  stationsError,
  isFetchedTasksDes,
  tasksDes,
  tasksDesError,
  getTaskDes,
  tasksDesSuccess,
  tasksSuccess,
  fetchTaskDes,
  fetchTasks,
  fetchModules,
  modulesMessage,
  getModulesAndStationRating,
  isFetchedRating,
  ratingError,
  ratingSuccess,
  modRating,
  stationRating,
  stationsSuccess,
  modulesSuccess,
  parkID,
  userError,
  dates,
  checkUpdatesSuccess,
}) {
  const [showTasks, setShowTasks] = useState({ show: false, id: 0, date: "" });
  const [allModules, setAllModules] = useState([]);
  const [stationOptions, setstationOptions] = useState([
    { label: "Select Station", value: "" },
  ]);
  const [dateOptions, setDateOptions] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [taskLoader, setTaskLoader] = useState({ loader: false, id: 0 });
  const [allTasks, setAllTasks] = useState([]);
  const [message, setMessage] = useState("");
  const [dDValues, setDDValues] = useState({
    date: "",
    station: "",
  });
  let history = useHistory();
  useEffect(() => {
    if (parkID) {
      const data = {
        park_id: parseInt(parkID),
      };
      getAllCheckUpdates(data);
    }
  }, [parkID]);
  useEffect(() => {
    if (parkID && dDValues?.date?.value) {
      setLoading(true);
      const data = {
        park_id: parseInt(parkID),
        date: dDValues?.date?.value,
      };
      getAllStations(data);
    } else {
      let stationOptions = [{ label: "Select Station", value: "" }];
      setstationOptions(stationOptions);
      setDDValues({
        ...dDValues,
        station: stationOptions.length > 1 ? stationOptions[0] : "",
      });
      setMessage("Please Select Date");
    }
  }, [dDValues.date]);
  useEffect(() => {
    return () => {
      fetchTaskDes();
      fetchTasks();
    };
  }, []);

  useEffect(() => {
    if (userError) setLoading(false);
  }, [userError]);

  useEffect(() => {
    if (stationsSuccess && isFetchedStations) {
      let stationOptions = [{ label: "Select Station", value: "" }];
      if (stations?.length) {
        stations.map((station, index) =>
          stationOptions.push({
            value: `${station.id}T${index}`,
            label: station.name,
          })
        );
        setstationOptions(stationOptions);
        setError("");
      } else {
        setMessage("No Checkup Exists");
        setLoading(false);
      }
      setDDValues({
        ...dDValues,
        station: stationOptions.length > 1 ? stationOptions[0] : "",
      });
      setLoading(false);
    } else if (stationsError) {
      setLoading(false);
      toast.error(`Error in getting stations ${stationsError}`);
      fetchModules();
    }
  }, [isFetchedStations]);

  useEffect(() => {
    if (checkUpdatesSuccess && isFetchedCheckUpdates) {
      let stationOptions = [{ label: "Select Station", value: "" }];
      let dateOptions = [{ label: "Select Date", value: "" }];
      if (stations?.length) {
        stations.map((station, index) =>
          stationOptions.push({
            value: `${station.id}T${index}`,
            label: station.name,
          })
        );
        setstationOptions(stationOptions);
        setError("");
      }
      const match = matchPath(history.location.pathname, {
        path: "/view-checkups/:date",
        exact: true,
        strict: false,
      });
      let matchedDate = null;
      if (match?.params?.date) {
        matchedDate = { value: match.params.date, label: match.params.date };
      }
      if (dates?.length) {
        dates.map((val) =>
          dateOptions.push({
            value: val.split("T")[0],
            label: val.split("T")[0],
          })
        );
        setDateOptions(dateOptions);
      } else {
        setMessage("No Checkup Exists");
        setLoading(false);
      }

      setDDValues({
        station: stationOptions.length > 1 ? stationOptions[0] : "",
        date: matchedDate
          ? matchedDate
          : dateOptions.length > 1
          ? dateOptions[1]
          : "",
      });
    } else if (stationsError) {
      setLoading(false);
      toast.error(`Error in getting stations ${stationsError}`);
      fetchModules();
    }
  }, [isFetchedCheckUpdates]);

  useEffect(() => {
    if (dDValues.date.value && dDValues.station.value) {
      const data = {
        date: dDValues.date.value,
        station_id: dDValues.station.value.split("T")[0],
        park_id: parseInt(parkID),
      };
      const ratingData = {
        date: dDValues.date.value,
        station_name: dDValues.station.label,
        park_id: parseInt(parkID),
      };
      getModules(data);
      getModulesAndStationRating(ratingData);
      setLoading(true);
      setAllTasks([]);
      setShowTasks({
        show: false,
        id: 0,
        index: null,
        date: dDValues.date.value,
      });
    } else if (dDValues.date.value) {
      setMessage("Please Select Station");
    }
  }, [dDValues.station]);

  useEffect(() => {
    if (isFetchedModules && modulesSuccess) {
      if (modules.length) {
        setAllModules(modules);
        setMessage("");
      } else if (modulesMessage && dDValues.station.value) {
        setMessage(modulesMessage);
        setLoading(false);
      }
    } else if (modulesError && dDValues.station.value) {
      setAllModules([]);
      setLoading(false);
      toast.error(`Error in getting modules ${modulesError}`);
      fetchModules();
      setMessage("");
    }
  }, [isFetchedModules]);

  useEffect(() => {
    if (isFetchedRating && ratingSuccess && dDValues.station.value) {
      let val = dDValues;
      val.station.ratingValue = stationRating;
      setDDValues(val);

      if (isFetchedModules && modulesSuccess) {
        setAllModules((previousData) => {
          let preData = [...previousData];
          preData.map((mod) =>
            modRating.filter((module) =>
              module.module_name === mod.name
                ? (mod.ratingValue = module.min)
                : ""
            )
          );
          return preData;
        });
      }

      setLoading(false);
    } else if (ratingError && isFetchedRating) {
      toast.error(`Error occured in getting modules rating ${ratingError}`);
      setLoading(false);
    }
  }, [isFetchedRating && isFetchedModules]);

  useEffect(() => {
    if (showTasks.id && isFetchedStations) {
      setTaskLoader({ loader: true, id: showTasks.index });
      const data = {
        module_id: showTasks.id,
        park_id: parseInt(parkID),
        date: dDValues.date.value,
      };
      getTasks(data);
      setShowTasks({ ...showTasks, show: true, date: dDValues.date.value });
    }
  }, [showTasks.index]);

  useEffect(() => {
    if (tasks?.length && tasksSuccess && dDValues.station.value) {
      setAllTasks(tasks);
      const data = {
        station_name: dDValues.station.label,
        module_name: allModules[showTasks.index].name,
        date: dDValues.date.value,
        park_id: parseInt(parkID),
      };
      getTaskDes(data);
    } else if (tasksError) {
      setTaskLoader({ id: taskLoader.id, loader: false });
      toast.error("Error in getting tasks", tasksError);
    }
  }, [isFetchedTasks]);

  useEffect(() => {
    if (tasksDes?.length && tasksDesSuccess) {
      let alltasks = [...allTasks];
      tasksDes.map((taskDes) =>
        alltasks.forEach((task) => {
          if (task.id === taskDes.task_id) {
            task.description = taskDes.task_description
              ? taskDes.task_description
              : "";
            task.ratingValue = taskDes.rating ? taskDes.rating : 0;
            task.update = true;
            task.images = taskDes.image_url;
            if (task.description || task.ratingValue || task.images?.length)
              task.backgroundColor = backgroundColor.black;
          }
        })
      );
      setAllTasks(alltasks);
      setTaskLoader({ id: taskLoader.id, loader: false });
    } else if (tasksDesSuccess && isFetchedTasksDes) {
      setTaskLoader({ id: taskLoader.id, loader: false });
    } else if (tasksDesError && isFetchedTasksDes) {
      setTaskLoader({ id: taskLoader.id, loader: false });
      toast.error(`Error in getting description ${tasksDesError}`);
    }
  }, [isFetchedTasksDes]);

  const onClickHeading = (id, index) => {
    setShowTasks({
      show: !showTasks.show,
      id,
      index,
      date: dDValues.date.value,
    });
  };
  const handleDDValues = (val, nameObj) => {
    const name = nameObj.name;
    setDDValues({
      ...dDValues,
      [name]: val,
    });
  };

  return (
    <div
      className="ViewCheckups"
      style={loading || message ? { height: "100vh" } : { height: "100%" }}
    >
      <Grid container className="container">
        <Grid item xs={5} md={4}>
          <Dropdown
            options={dateOptions}
            placeholder="Select Date"
            id="date"
            name="date"
            value={dDValues.date}
            onChange={handleDDValues}
            key="date"
          />
        </Grid>
        <Grid item xs={5} md={4}>
          <Dropdown
            options={stationOptions}
            placeholder="Select Station"
            id="station"
            value={dDValues.station}
            name="station"
            onChange={handleDDValues}
            key="station"
          />
        </Grid>
      </Grid>
      {loading ? (
        <Loader />
      ) : message ? (
        <Message message={message} />
      ) : (
        !!dDValues.station.value && (
          <>
            <div className="main" key="main-heading">
              <h1 className="main-heading" key="heading">
                {dDValues.station.label}
              </h1>
              <span className="rating-box" key="index">
                <StyledRating
                  name="customized-color"
                  defaultValue={0}
                  getLabelText={(value) =>
                    `${value} Star${value !== 1 ? "s" : ""}`
                  }
                  precision={1}
                  icon={<StarsIcon fontSize="inherit" />}
                  className="rating"
                  emptyIcon={
                    <StarsIcon
                      fontSize="inherit"
                      style={{ color: backgroundColor.grey }}
                    />
                  }
                  readOnly
                  value={dDValues.station.ratingValue}
                />
              </span>
            </div>

            {allModules.map((module, index) => (
              <>
                <PaperCard
                  heading={module.name}
                  id={index}
                  onClickHeading={() => onClickHeading(module.id, index)}
                  main={true}
                  taskLoader={taskLoader}
                  taskIndex={index}
                  ratingReadonly
                  key={`last checkup ${index}`}
                  ratingValue={module.ratingValue}
                  ratingColor={
                    module.ratingValue >= 1 && module.ratingValue < 3
                      ? ratingColor.red
                      : module.ratingValue >= 3 && module.ratingValue < 4
                      ? ratingColor.yellow
                      : ratingColor.green
                  }
                />
                {index === showTasks.index &&
                showTasks.show &&
                allTasks.length &&
                !taskLoader.loader
                  ? allTasks.map((task, subIndex) => (
                      <PaperCard
                        heading={task.name}
                        description={task.description}
                        ratingColor={
                          task.ratingValue >= 1 && task.ratingValue < 3
                            ? ratingColor.red
                            : task.ratingValue >= 3 && task.ratingValue < 4
                            ? ratingColor.yellow
                            : ratingColor.green
                        }
                        ratingValue={task.ratingValue}
                        id={`${module.id} - ${task.id}`}
                        ratingReadonly={true}
                        key={`last checkup ${index} + ${subIndex}`}
                        backgroundColor={
                          task.backgroundColor
                            ? task.backgroundColor
                            : backgroundColor.gray
                        }
                        images={task.images}
                      />
                    ))
                  : ""}
              </>
            ))}
          </>
        )
      )}
      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    isFetchedCheckUpdates: state?.stations?.checkUpdates?.isFetched,
    isFetchedStations: state?.stations?.stations?.isFetched,
    isFetchedModules: state?.stations?.modules?.isFetched,
    isFetchedTasks: state?.stations?.tasks?.isFetched,
    stations: state?.stations?.stations?.stations,
    dates: state?.stations?.checkUpdates?.dates,
    stationsSuccess: state?.stations?.stations?.success,
    tasks: state?.stations?.tasks?.tasks,
    modules: state?.stations?.modules?.modules,
    modulesMessage: state?.stations?.modules?.message,
    modulesError: state?.stations?.modules?.error,
    modulesSuccess: state?.stations?.modules?.success,
    tasksError: state?.stations?.tasks?.error,
    tasksSuccess: state?.stations?.tasks?.success,
    stationsError: state?.stations?.stations?.error,
    tasksDes: state?.stations?.tasksDes?.tasksDes,
    tasksDesError: state?.stations?.tasksDes?.error,
    isFetchedTasksDes: state?.stations?.tasksDes?.isFetched,
    tasksDesSuccess: state?.stations?.tasksDes?.success,
    isFetchedRating: state?.stations?.modAndStationRating?.isFetched,
    ratingError: state?.stations?.modAndStationRating?.error,
    ratingSuccess: state?.stations?.modAndStationRating?.success,
    modRating: state?.stations?.modAndStationRating?.modRating,
    stationRating: state?.stations?.modAndStationRating?.stationRating,
    parkID: state?.users?.getUser?.user?.park_id,
    userError: state?.users?.getUser?.error,
    checkUpdatesSuccess: state?.stations?.checkUpdates?.success,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAllCheckUpdates: (data) => dispatch(getAllCheckUpdates(data)),
    getAllStations: (parkID) => dispatch(getAllStations(parkID)),
    getModules: (data) => dispatch(getModules(data)),
    getTasks: (moduleID) => dispatch(getTasks(moduleID)),
    getTaskDes: (data) => dispatch(getTaskDes(data)),
    fetchTaskDes: () => dispatch(fetchTaskDes()),
    fetchTasks: () => dispatch(fetchTasks()),
    fetchModules: () => dispatch(fetchModules()),
    getModulesAndStationRating: (data) =>
      dispatch(getModulesAndStationRating(data)),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ViewCheckups)
);
